export enum EPolicyUrls {
  POLICY = 'policy',
  DOC = 'doc',
  SUPPORTED_STATES = 'supported-states',
  POLICY_CONTENT_SUGGESTION = 'policy-content-suggestion',
  SEARCH = 'search',
  CHARGE_INFO = 'charge-info',
  GENERIC = 'generic',
}
